export class Generar_cuenta_extra{
    constructor(
        public numero_cuenta: String,
        public nombre_cuenta: String,
        public tipo_sueldo: String

    ){}
}